import styled from 'styled-components'
import { IconComponent } from 'ui'

export const Message = styled.div`
    font-weight: normal;

    strong {
        font-weight: bold;
    }
`

export const Icon = styled(IconComponent)`
    display: inline-block;
    margin-right: 5px;
    vertical-align: middle;
`
